/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Truncate {
  /**
   * Truncate string when longer than maxLength and add the Unicode Character horizontal ellipsis keeping the total within maxLength.
   *
   * @public
   * @function f1.word
   * @param max the maximum length of the string to permit
   * @param s any string
   * @example
   *
   * ```ts
   * truncate(5, 'super') === 'super'
   * truncate(4, 'super') === 'sup...'
   * ```
   */
  (max: number, s: string): string;
  (max: number): (s: string) => string;
}

/**
 * @see Truncate
 */
export default (max: number, s: string) => {
  return s.length > max ? `${s.substr(0, max - 1)}...` : s;
};
